import { Helmet } from 'react-helmet-async';
import BrandClusterManager from 'src/sections/cluster-manager/brand-cluster-manager';

export default function SearchPerformanceClusterManager() {
  return (
    <>
      <Helmet>
        <title>Cluster Manager</title>
      </Helmet>

      <BrandClusterManager />
    </>
  );
}
